
 

 

 

 
class DashboardSearchCriteria 
{
    
        StationId: string | null;
    
        StationIds: any;
    
        PeriodType: number | null;
    
        OutputType: number | null;
    
        DateTimeStart: Date | null;
    
        DateTimeEnd: Date | null;
    
        AirQualityType: string;
    
        AirQualityTypeList: any;
    
        DistrictId: string | null;
    
        DistrictGroupId: string | null;
    
        IsCreate: boolean | null;
    
}
 
export default DashboardSearchCriteria;
 




